import { getComponentFromName } from '@folklore/utils';
import classNames from 'classnames';
import isString from 'lodash-es/isString';
import { ElementType } from 'react';

import useDocuments, {
    useNextDocuments,
    usePopularDocuments,
    useRelatedDocuments,
} from '../../hooks/useDocuments';

import * as CardComponents from '../cards/documents';
import PresentationList, { PresentationListProps } from './PresentationList';

import styles from '../../styles/lists/documents-list.module.css';

const hooks = {
    popular: usePopularDocuments,
    default: useDocuments,
    next: useNextDocuments,
    related: useRelatedDocuments,
};

export interface DocumentsListProps extends Omit<
    PresentationListProps<FullDocument>,
    'cardComponent'
> {
    type?: string | null;
    query?: Record<string, unknown> | null;
    hook?: typeof useDocuments | typeof useNextDocuments | string;
    cardComponent?: ElementType | null;
    cardType?: string;
    itemsClassName?: string | null;
    className?: string | null;
    cardClassName?: string | null;
}

function DocumentsList({
    type = null,
    query = null,
    cardType = 'vertical',
    hook = 'default',
    cardComponent = null,
    itemsClassName = null,
    className = null,
    cardClassName = null,
    ...props
}: DocumentsListProps) {
    const finalQuery =
        type !== null
            ? {
                  type,
                  ...query,
              }
            : query;

    const placeholderItem = {
        type: finalQuery !== null ? finalQuery.type || null : null,
    };

    return (
        <PresentationList<FullDocument>
            query={finalQuery}
            placeholderItem={placeholderItem}
            hook={isString(hook) ? hooks[hook] || hooks.default : hook}
            {...props}
            cardComponent={
                cardComponent ||
                getComponentFromName(CardComponents, cardType, CardComponents.Vertical)
            }
            className={classNames([className])}
            itemsClassName={classNames([itemsClassName])}
            rowClassName={styles.row}
            cardClassName={classNames([styles[type], cardClassName])}
        />
    );
}

export default DocumentsList;
